import React from "react";

const oldAuctions = [
  { week: "August 10–17, 2026 — Dynadot Auctions", domains: [
    { domain: "xn--6xa.cc", displayName: "υ.cc", details: "DotDB: 500, registered 2021", startPrice: 299 },
    { domain: "188.ch", details: "DotDB: 194, GodaddyList: $18,384, registered 2016", startPrice: 299 },
    { domain: "Renminbi.cc", details: "DotDB: 51, GodaddyList: $6,515, registered 2022", startPrice: 299 },
    { domain: "Oeu.co", details: "DotDB: 43, GodaddyList: $10,143, registered 2014", startPrice: 299 },
    { domain: "Xih.co", details: "DotDB: 25, GodaddyList: $7,162, registered 2023", startPrice: 299 },
    { domain: "Suites.top", details: "DotDB: 90, Dynadot: $4,733, registered 2018", startPrice: 299 },
    { domain: "Dispute.cc", details: "DotDB: 92, Dynadot: $837, registered 2020", startPrice: 299 },
    { domain: "Wtdk.com", details: "DotDB: 6, Estibot: $5,900, registered 2004", startPrice: 1500 },
    { domain: "Hqr.net", details: "DotDB: 53, Dynadot: $6,254, registered 2000", startPrice: 1500 },
    { domain: "Uqfy.com", details: "DotDB: 2, Estibot: $7,600, registered 2012", startPrice: 299 },
    { domain: "66666.eu", details: "DotDB: 134, Dynadot: $2,682", startPrice: 299 },
    { domain: "Uxy.xyz", details: "", startPrice: 1500 },
    { domain: "Flbu.com", details: "DotDB: 3, GodaddyValue: $2,679, registered 2006", startPrice: 1500 },
    { domain: "Legalaid.eu", details: "GodaddyList: $2,816", startPrice: 299 },
  ]},
];

const font = "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif";

const OldArchive = () => (
  <div style={{ minHeight: "100vh", background: "#000", color: "#fff", fontFamily: font, padding: "120px 24px 60px" }}>
    <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: 800, marginBottom: "8px" }}>Archive</h1>
      <p style={{ color: "rgba(255,255,255,0.5)", marginBottom: "40px" }}>Previous auction listings</p>
      <a href="/" style={{ color: "#1FE2A5", textDecoration: "none", fontSize: "0.9rem", fontWeight: 600 }}>&larr; Back to current listings</a>
      {oldAuctions.map((week, wi) => (
        <div key={wi} style={{ marginTop: "32px" }}>
          <h2 style={{ fontSize: "1.2rem", fontWeight: 700, marginBottom: "16px", color: "#1FE2A5" }}>{week.week}</h2>
          <div style={{ borderRadius: "16px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)", background: "rgba(255,255,255,0.015)" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid rgba(31,226,165,0.15)" }}>
                  <th style={{ textAlign: "left", padding: "12px 24px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.12em" }}>Domain</th>
                  <th style={{ textAlign: "left", padding: "12px 24px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.12em" }}>Starting Price</th>
                  <th style={{ textAlign: "left", padding: "12px 24px", color: "#1FE2A5", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.12em" }}>Details</th>
                </tr>
              </thead>
              <tbody>
                {week.domains.map((d, i) => (
                  <tr key={d.domain} style={{ backgroundColor: i % 2 === 0 ? "rgba(255,255,255,0.02)" : "transparent", borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
                    <td style={{ padding: "14px 24px", fontWeight: 700, fontSize: "1rem" }}>{d.displayName || d.domain}</td>
                    <td style={{ padding: "14px 24px", color: "rgba(255,255,255,0.8)" }}>${d.startPrice.toLocaleString("en-US")}</td>
                    <td style={{ padding: "14px 24px", color: "rgba(255,255,255,0.5)", fontSize: "0.85rem" }}>{d.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default OldArchive;
